import React from 'react';
import PropTypes from 'prop-types';
import {
  add, compose, defaultTo, path,
} from 'ramda';
import { parse, stringify } from 'qs';
import { withRouter } from 'react-router-dom';

import Pagination from '../../components/Pagination';
import BackButton from '../../components/BackButton';
import { smoothScroll } from '../../helpers/view';
import ArtistBlock from './ArtistBlock/ArtistsBlock';
import { ReleaseBlock } from './ReleaseBlock/ReleaseBlock';
import SeriesBlock from './SeriesBlock/SeriesBlock';
import GenresBlock from './GenresBlock/GenresBlock';
import TracksBlock from './TracksBlock/TracksBlock';

import c from './Search.less';

const searchTypes = {
  artists: {
    component: ArtistBlock,
    moreTitle: 'Show more artists',
    fpn: '/catalog/search/artist',
  },
  releases: {
    component: ReleaseBlock,
    moreTitle: 'Show more releases',
    fpn: '/catalog/search/release',
  },
  series: {
    component: SeriesBlock,
    moreTitle: 'Show more series',
    fpn: '/catalog/search/series',
  },
  genres: {
    component: GenresBlock,
    moreTitle: 'Show more genres',
    fpn: '/catalog/search/genre',
  },
  tracks: {
    component: TracksBlock,
    moreTitle: 'Show more tracks',
    fpn: '/catalog/search/song',
  },
};

class SearchByType extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    results: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  componentDidMount() {
    smoothScroll();
  }

  handlePageChange = () => {
    const { q } = this.props.location.query;
    const { type } = this.props.match.params;

    const page = compose(
      add(1),
      defaultTo(1),
      path(['location', 'query', 'page']),
    )(this.props);

    const searchQuery = {
      q,
      page,
    };

    return this.props.history.push(`/search/${type}?${stringify(searchQuery)}`);
  };

  render() {
    const {
      location, results: { items, total }, type, loading,
    } = this.props;

    const { q, page } = parse(location.search.slice(1));

    const ResultBlock = searchTypes[type].component;

    return (
      <div>
        <BackButton to={`/search?q=${q}`} title="Search" desktopHidden={false} />
        <ResultBlock items={items} q={q || ''} standalone />
        <div className={c.paginationContainer}>
          <Pagination
            showPages={false}
            pageSize={20}
            currentPage={page}
            total={total}
            isLoading={loading}
            onLoadMore={this.handlePageChange}
            className={c.pagination}
            showMoreTitle={searchTypes[type].moreTitle}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(SearchByType);
